import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import injectTapEventPlugin from "react-tap-event-plugin";
import './index.css';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
// injectTapEventPlugin();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js